/**
 *
 *@author zcc
 *@date 2022/3/14 10:26
 */
import { BaseViewModel } from '@/viewmodel/BaseViewModel';

export class WebMenuViewModel extends BaseViewModel {
  menuList: any;
  defaultActive: any;
  opends = ['0', '1', '2'];
  private defaultHash: any;

  created() {
    this.setDefaultActive();
  }

  routerChangeEvent() {
    if (this.$route.path.indexOf('home') > -1) {
      return;
    }
    this.setDefaultActive();
    const hash = this.$route.hash.split('#')[1];
    if (!hash) {
      return;
    }
    const el = document.getElementById(hash) as HTMLElement;
    if (el) {
      el.click();
    }
  }

  handleClose(index: any) {
    (this.$refs['menu'] as any).open(index);
  }

  select(fileName: string) {
    this.$emit('showMdFile', fileName);
  }

  private setDefaultActive() {
    const defaultHash: any = this.$route.hash;
    this.defaultHash= defaultHash ? defaultHash.replace('#', '') : 'fastStart';
    const indexObj = this.getActiveMenuIndex(this.defaultHash);
    this.defaultActive = this.menuList[indexObj.groupIndex].list[indexObj.itemIndex].id;
  }

  private getActiveMenuIndex(hash: string) {
    const indexObj = {
      groupIndex: 0,
      itemIndex: 0
    };
    if (!hash) {
      return indexObj;
    }
    this.menuList.forEach((group: any, groupIndex: number) => {
      group.list.forEach((item: any, itemIndex: number) => {
        if (item.id === hash) {
          indexObj.groupIndex = groupIndex;
          indexObj.itemIndex = itemIndex;
        }
      });
    });
    return indexObj;
  }
}
